/**
 * RTK Query service for the B2C dashboard composite endpoint.
 *
 * GET /api/v1/b2c/dashboard/init returns:
 *   { pipeline, application_status, current_offer, amortization,
 *     borrower_profile (lightweight summary), document_counts,
 *     documents (null — counts replace full tree for dashboard) }
 *
 * This replaces individual queries the dashboard page previously fired
 * on every mount, cutting network round-trips and middleware traversals.
 */
import { createApi } from '@reduxjs/toolkit/query/react';
import { getHeaders } from 'auth/auth';
import { baseQueryWithReauth } from '../baseQuery';

export const compositeInitAPI = createApi({
  reducerPath: 'compositeInitAPI',
  tagTypes: ['dashboardInit'],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getDashboardInit: builder.query({
      query: () => ({
        url: 'b2c/dashboard/init',
        method: 'GET',
        headers: getHeaders(),
      }),
      keepUnusedDataFor: 120, // cache for 120s (payload includes profile + doc counts)
      providesTags: ['dashboardInit'],
    }),
  }),
});

export const { useGetDashboardInitQuery } = compositeInitAPI;
